/**
 * The IT training content, bundled: every `content/<lang>/*.md` as raw text,
 * parsed once into the lesson index.
 *
 * To add a lesson, add `content/en/<slug>.md` (see `lib/lessons.ts` for the
 * format) and, if it is news, a line in `content/en/_whats-new.md`. Nothing
 * else to wire: the glob below picks the file up. A malformed file fails the
 * node test (`tests/it-training.test.mjs`) before it can fail the page.
 */

import { buildLessonIndex, type LessonIndex } from "./lib/lessons";

const FILES = import.meta.glob<string>("./content/*/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
});

export const LESSON_INDEX: LessonIndex = buildLessonIndex(FILES);
